import React from "react";

import "../Style/_services.scss";

// =======================================================
// MainContent class as Javascript function
// =======================================================
function MainContent() {
  return (
    <>
      <div className="services-container section">
        <h3>La réflexologie plantaire : un soin adapté à tous</h3>
        <br></br>
        <br></br>
        <div className="service-section">
          <h4>Pour les adultes :</h4>
          <p>Des séances de 45 à 60 minutes pour libérer les tensions et favoriser une meilleure circulation énergétique dans le corps.</p>
        </div>
        <div className="service-section">
          <h4>Pour les enfants :</h4>
          <p>Des séances adaptées d'environ 30 minutes, pour un moment de détente et d'équilibre.</p>
        </div>
        <div className="deroulement">
          <h4>Déroulement d’une séance :</h4>
          <p>Nous prendrons un temps d’échange afin de connaître vos attentes sur la séance, puis vous vous installerez sur la table de massage.</p>
          <p>Le soin dure environ 45 à 60 minutes. Pour les enfants, les séances sont d’environ 30 minutes.</p>
        </div>
        <br></br>
        <br></br>
        <div className="service-section">
          <h4>Tarifs réflexologie plantaire :</h4>
          <p>
            <strong className="less-bold">Particuliers :</strong> 55 euros la séance. (la 5ᵉ à 45 euros)
          </p>
          <p>
            <strong className="less-bold">Enfants :</strong> 30 euros la séance.
          </p>
          <br></br>
          <h4>Tarifs soins énergétiques - magnétiseur - coupeur de feu :</h4>
          <p>
            55 euros la séance en présentiel ou 40 euros en distanciel (zona, brûlures, eczéma, inflammations).
          </p>
          <br></br>
          <br></br>
          <div className="clause_section">
            <h5>Clause de non-responsabilité</h5>
            <p>
              Les services proposés (magnétisme, coupeur de feu, soins énergétiques) relèvent des pratiques de bien-être et de relaxation.
              Ils ne constituent en aucun cas un acte médical, paramédical ou thérapeutique au sens de la loi.
            </p>
            <p>
              Ces prestations ne remplacent ni un diagnostic médical, ni un traitement prescrit par un professionnel de santé.
              Il est fortement recommandé de consulter un médecin ou un spécialiste qualifié pour toute problématique médicale.
            </p>
            <p> 
              Aucune interruption de traitement médical ne doit être effectuée sans l’avis préalable de votre médecin.
              Les résultats pouvant varier d’une personne à l’autre, aucune garantie de résultat ne peut être donnée.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default MainContent;
